import React from "react";
import AboutTrip from "./AboutTrip";
import ContactForm from "./Contact";

const Final = ({packageData}) => {
  return (
    <div className="">
      <AboutTrip packageData ={packageData} />
      <ContactForm />
    </div>
  );
};

export default Final;
